jQuery(function () { 

      //Placeholder animado del buscador
  var textbox = $('.search-index-input'),
  captionList = [
      'Policía Nacional',
      'Guardia Civil',
      'Auxiliar Administrativo',
      'Correos',
      'Bomberos',
      'Policía Local',
      'Auxilio Judicial',
      'Enfermería de Servicios de Salud',
      'Celador',
      'Educación Primaria',
  ],
  captionCurrentIndex = 0,
  captionLength = 0,
  caption = '',
  id = setTimeout(TypingEffect, 600);


  function TypingEffect() {
    if (captionCurrentIndex >= captionList.length){
        captionCurrentIndex = 0
    } 
    caption = captionList[captionCurrentIndex]
    captionCurrentIndex++

    clearTimeout(id); //clear first clearTimeout(TypingEffect, 600) call
    captionLength = 1; //start at 0
    id = setInterval(type, 50); //call type every 50ms
  }

  function type() {
    textbox.prop("placeholder", caption.substring(0, captionLength++));

    if (captionLength === caption.length + 1) {
        clearInterval(id); //clear clearInterval(type, 50) 
        id = setTimeout(ErasingEffect, 1500); //start ErasingEffect call once after delay
    }
  }

  function ErasingEffect() {
    clearTimeout(id); //clear clearTimeout(ErasingEffect, 2000); call 
    captionLength = caption.length; //start at end
    id = setInterval(erase, 20); //call erase every 50ms
  }

  function erase() {
    textbox.prop("placeholder", caption.substring(0, captionLength--));

    //when finshed erasing clear interval and call type
    if (captionLength < 0) {
        clearInterval(id); //clear clearInterval(erase, 50)
        id = setTimeout(TypingEffect, 500); //start over
    }
  }


});